import { render, staticRenderFns } from "./WebtestTooltip.vue?vue&type=template&id=25be15c0&scoped=true"
import script from "./WebtestTooltip.vue?vue&type=script&setup=true&lang=js"
export * from "./WebtestTooltip.vue?vue&type=script&setup=true&lang=js"
import style0 from "./WebtestTooltip.vue?vue&type=style&index=0&id=25be15c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25be15c0",
  null
  
)

export default component.exports